import { Mark } from '@tiptap/core';
// Unused but kept for future reference
// import { figuresStore } from '../../stores/figuresStore';

// FigureReference extension

export const FigureReference = Mark.create({
    name: 'figureReference',
    
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },

    addAttributes() {
        return {
            figureKey: {
                default: null,
                parseHTML: element => element.getAttribute('data-figure-key'),
                renderHTML: attributes => {
                    return {
                        'data-figure-key': attributes.figureKey,
                        'class': 'figure-reference',
                    };
                },
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'span[data-figure-key]',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['span', HTMLAttributes, 0];
    },

    addCommands() {
        return {
            setFigureReference: (attributes) => ({ commands }) => {
                return commands.setMark(this.name, attributes);
            },
            removeFigureReference: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },

    addKeyboardShortcuts() {
        return {
            'Mod-@': () => {
                // This will be handled by the editor's keydown handler
                return true;
            },
        };
    },

    // Removed figure validation plugins - error handling moved to export time
    // addProseMirrorPlugins() {
    //     return [];
    // },
});
